import { useMutation } from '@apollo/client';
import * as Sentry from '@sentry/react';

import logger from 'js/app/loggerSingleton';

import PROGRAM_MEMBERSHIP_RESEND_VERIFICATION_EMAIL_MUTATION from 'bundles/enterprise-legacy-learner-home/queries/ProgramMembershipResendVerificationEmail.graphql';
import type {
  ProgramMembership_ResendVerificationEmailMutation as ResendVerificationEmailMutation,
  ProgramMembership_ResendVerificationEmailMutationVariables as ResendVerificationEmailMutationVariables,
} from 'bundles/enterprise-legacy-learner-home/queries/__generated__/ProgramMembershipResendVerificationEmail';

export function useResendVerificationEmail() {
  const [resendEmail] = useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(
    PROGRAM_MEMBERSHIP_RESEND_VERIFICATION_EMAIL_MUTATION,
    {
      context: { clientName: 'gatewayGql' },
    }
  );

  const resendVerificationEmail = async (params: { programId: string; userId: number; redirectUrl?: string }) => {
    try {
      const response = await resendEmail({
        variables: {
          input: {
            programMembershipId: {
              programId: params.programId,
              userId: params.userId,
            },
            redirectUrl: params.redirectUrl,
          },
        },
      });

      if (
        response.data?.ProgramMembership_ResendVerificationEmail.__typename ===
        'ProgramMembership_ResendVerificationEmailResultFailure'
      ) {
        throw new Error(response.data.ProgramMembership_ResendVerificationEmail.error);
      }

      return response.data?.ProgramMembership_ResendVerificationEmail;
    } catch (e) {
      logger.error('Failed to resend verification email', e);
      Sentry.captureException(e as Error);
      throw e;
    }
  };

  return {
    resendVerificationEmail,
  };
}
